export var defaultTheme = {
    primary: "#fff",
    secondary: "#000",
    tertiary: "#ffffff99",
    text_primary: "#000",
    text_secondary: "#fff",
    text_tertiary: "#00000044",
    disableThemeScrollbar: false,
};
